import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import { isMobile } from '../services/DeviceInformation';

const propTypes = {
    children: PropTypes.node,
};

/**
 * Reusable container that applies space in between and around its children
 * For registration, login and error pages
 */
const Container = ({ children }) => {
    const desktopCSS = ({ white }) => {
        return css`
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1.6667rem;
            padding: 3.333rem;
            width: 420px;
            background-color: ${white};
            border-radius: 8px;
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);
            overflow-wrap: anywhere;
            text-align: center;

            &:has(.vaultsPage) {
                padding: 3.3333rem 0 1.6667rem;
                width: 500px;
            }
        `;
    };

    const mobileCSS = ({ white }) => {
        return css`
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1.6667rem;
            margin: auto;
            background-color: ${white};
            overflow-wrap: anywhere;
            text-align: center;
            width: 100%;
        `;
    };

    return <div css={isMobile() ? mobileCSS : desktopCSS}>{children}</div>;
};

Container.propTypes = propTypes;

export default Container;
